import React from 'react';
import MenuUtils from '../../common';
import Timer from '../Timer';
import styles from './KitchenSection.module.css';

const LeftSection = ({ item }) => {
    return (
        <div className={styles.leftWrapper}>
            <div className={styles.squareBox}></div>
            <Timer info={item.orderedAt} textStyle={styles.time} />
        </div>
    );
};

const RightSection = ({ item }) => {
    return (
        <div className={styles.leftWrapper}>
            <span className={styles.check}>{item.serverName}</span>
            <div className={styles.tableNameContainer}>
                <span className={styles.tableNum}>{item.stationName}</span>
            </div>
            <span className={styles.check}>#{item.checkNumber}</span>
        </div>
    );
};

const KitchenSection = (props) => {
    const {
        onPaginateLeft = () => { },
        onPaginateRight = () => { },
        onItemClick = () => { },
        ordersToBeShown = [],
    } = props;

    console.log('ordersToBeShown', ordersToBeShown)
    const toTitleCase = (text = '') => {
        text = text
            .toLowerCase()
            .split(' ')
            .map(s => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
        return text;
    };

    const renderModifiersRecursively = im => {
        return MenuUtils.renderModifiersRecursively(
            im,
            0,
            (i, index) => renderModifiers(i, index),
            i => rendereItem(i),
            true,
        );
    };

    const rendereItem = item => (
        <span className={styles.itemName}>{toTitleCase(item.menuItemName || item.name)}</span>
    );

    const renderModifiers = (menuItem, index) => (
        <div key={`modifier-${menuItem.id}`} className={styles.modifierWrapper}>
            <span className={styles.modifier} style={{ paddingLeft: `${index * 7 * 0.65}vh` }}>
                {toTitleCase(menuItem.modifierName || menuItem.menuItemName)}
            </span>
        </div>
    );

    return (
        <div className={styles.container}>
            <span className={styles.sideArrow} onClick={onPaginateLeft}>&lt;</span>
            <div className={styles.mainWrapper}>
                {ordersToBeShown.length && ordersToBeShown.map(item => (
                    <div key={`checkItemId-${item.checkItemId}`} className={styles.sectionWrapper} onClick={() => onItemClick(item)}>
                        <LeftSection item={item} />
                        <div className={styles.bodyWrapper}>
                            {renderModifiersRecursively(item)}
                        </div>
                        <RightSection item={item} />
                    </div>
                ))}
            </div>
            <span className={styles.sideArrow} onClick={onPaginateRight}>&gt;</span>
        </div>
    );
};

export default KitchenSection;
